import { Pipe, PipeTransform } from '@angular/core';
import { INotification } from './notification.interface';

@Pipe({
  name: 'unreadNotificationsCount',
})
export class UnreadNotificationsPipe implements PipeTransform {
  public transform(notifications: INotification[]): number {
    return notifications.filter(item => !item.read).length;
  }
}
